export function getMyPermissions(): string[] {
  try {
    return JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch {
    return [];
  }
}

export function hasPermission(permission: string): boolean {
  return getMyPermissions().includes(permission);
}

export function getMyUserId(): number | null {
  const id = localStorage.getItem("userId");
  return id ? parseInt(id, 10) : null;
}

export function getMyEmail(): string | null {
  return localStorage.getItem("email");
}

// Customer Experience - not a role (both already hold Business Development
// today; the business explicitly asked not to introduce a new role for just
// two people), so this is a hardcoded allowlist mirroring the backend's
// CX_USER_EMAILS in fdc.py. Gates: the "Goodwill" record-type option on the
// create wizard, the Customer Experience menu, and the Nirban-approval note
// on a Goodwill project. Adding a third CX person means adding their email
// here AND in fdc.py.
const CX_USER_EMAILS = new Set([
  "manmohan@spokesly.com",
  "anjali.karwa@spokesly.com",
]);

export function isCXUser(): boolean {
  const email = getMyEmail();
  return !!email && CX_USER_EMAILS.has(email);
}

// The single named approver for every "goodwill" project - mirrors
// GOODWILL_APPROVER_EMAIL in fdc.py.
const GOODWILL_APPROVER_EMAIL = "nirban@spokesly.com";

export function isGoodwillApprover(): boolean {
  return getMyEmail() === GOODWILL_APPROVER_EMAIL;
}
